export default "__VITE_ASSET__BbYOGRxU__"